import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterSelectionListComponent } from '../filter-selection-list/filter-selection-list.component';
import { PopOverService } from '../../../core/services/pop-over.service';
import { FilterService } from '../../../core/interfaces/filter/filter-service';

@Component({
  selector: 'app-filter-selection',
  templateUrl: './filter-selection.component.html',
  styleUrls: ['./filter-selection.component.scss'],
})
export class FilterSelectionComponent implements OnInit, OnDestroy {
  @Input() filterOptions: any;
  @Input() service: FilterService;
  @Input() cssClass: string;

  private subscriptions: Subscription[] = [];
  private overlay: HTMLIonPopoverElement;

  constructor(private popOverService: PopOverService) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onClick() {
    const onCancel = new EventEmitter();
    const onSave = new EventEmitter<any>();

    this.popOverService
      .showPopOver(
        FilterSelectionListComponent,
        {
          filterOptions: this.filterOptions,
          onCancel,
          onSave,
        },
        ''
      )
      .subscribe((element) => {
        this.overlay = element;
        this.overlay.animated = false;
        this.overlay.present();
      });

    // exit on cancel
    this.subscriptions.push(
      onCancel.subscribe(() => {
        this.popOverService.dismissPopOver(this.overlay);
        this.cleanUp();
      })
    );

    // exit on save
    this.subscriptions.push(
      onSave.subscribe((newSelection) => {
        this.popOverService.dismissPopOver(this.overlay);
        this.service.setFilterOptions(newSelection, null);
        this.cleanUp();
      })
    );
  }

  cleanUp() {
    this.overlay = null;
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }
}
